// extracted by mini-css-extract-plugin
module.exports = {"product-card":"card_product-card__0sBmD","tag":"card_tag__ouh4W"};